import { getEventContent } from '../../api/api'
import { WorkshopContentNoAuth } from '../../pages/Workshop/WorkshopContentNoAuth'
import { createFileRoute } from '@tanstack/react-router'
import type { StudyStatus } from './_app.study.$studyId';

export const Route = createFileRoute(
  '/(app)/_app/workshops_/$type/$workshopId',
)({
  component: WorkshopContentNoAuth,
  validateSearch: (search: Record<string, unknown>): { status: StudyStatus } => {
    return {
      status: (search["status"] as StudyStatus) || 'unknown',
    };
  },
  loader: async ({params}) => {
    const workshopContent = await getEventContent(Number(params.workshopId));
    return {
      data: workshopContent
    }
  }
})
